module["exports"] = [
  "#####"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/it/address/postcode.js
 ** module id = 677
 ** module chunks = 0
 **/